<script setup lang="ts">
    import './index.scss';
    import { countryList, dishList } from '~/db/data';

    const emit = defineEmits<{
        (e: 'changeEvent', data?: any): void,
    }>()

    const viewport = useViewport()
    const props = defineProps({
        inputName: {
            type: String,
            default: 'text', 
        },
        type: {
            type: String as PropType<'search' | 'default'>,
            default: 'default',
            required: false,
        },
        icon: {
            type: String,
            default: '',
            required: false,
        },
        class: {
            type: String,
            required: false
        },
        placeholder: {
            type: String,
            defaultValue: '',
            required: false
        }
    })

    const classObject = computed(() => ({
        'rounded-none' : props.type == 'default',
        'rounded-[0.8rem] border-[lightGray] border-solid border-[1px] h-[5.3rem] max-md:h-[4rem]' : props.type == 'search',
    }))

    const { value, setValue, errorMessage }: any = useField(props.inputName)
    const isOpen = ref(false)

    const countryTagList = ref(countryList)
    const dishTagList = ref(dishList)
    const countryTagAnswer = ref<any[]>([]);
        const dishTagAnswer = ref<any[]>([]);

    countryTagList.value.forEach((u: any) => {
        u.checked = false
    })

    dishTagList.value.forEach((u: any) => {
        u.checked = false
    })

    console.log('the current', value.value);

    const handleChange = (
        tag: {
            label: string;
            value: string;
            checked: boolean
        },
        checked: boolean, type: 'country' | 'dish'
    ) => {
        const totalSelected =
            countryTagList.value.filter((t) => t.checked).length +
            dishTagList.value.filter((t) => t.checked).length;

        if (checked && totalSelected > 2) {
            tag.checked = false;
            return;
        }

        countryTagAnswer.value = countryTagList.value
            .filter((t) => t.checked)
            .map((t) => ({ label: t.label, value: t.value }));

        dishTagAnswer.value = dishTagList.value
            .filter((t) => t.checked)
            .map((t) => ({ label: t.label, value: t.value }));
    };

    const updateValue = (event: any) => {
        if (event.length > 0) {
            console.log(event);
            let oldValue = value.value;
            // setValue(oldValue.filter((y: any) => y.label != event[0].label));

            // Find the removed item
            const removedItem = oldValue.find((y: any) => !event.some((e: any) => e.label === y.label));
            if (removedItem) {
                // Update the respective tag list to uncheck the removed item
                const targetList = countryTagList.value.concat(dishTagList.value);
                const tagToUncheck = targetList.find((t: any) => t.label === removedItem.label);

                if (tagToUncheck) {
                    tagToUncheck.checked = false;
                }
            }

            setValue(event);
        } else {
            countryTagList.value.forEach((t) => (t.checked = false));
            dishTagList.value.forEach((t) => (t.checked = false));

            setValue([]);
        }

        countryTagAnswer.value = countryTagList.value
            .filter((t) => t.checked)
            .map((t) => ({ label: t.label, value: t.value }));

        dishTagAnswer.value = dishTagList.value
            .filter((t) => t.checked)
            .map((t) => ({ label: t.label, value: t.value }));
    }

    const setCategory = () => {
        const value = [...countryTagAnswer.value, ...dishTagAnswer.value];
        setValue(value);
        isOpen.value = false;
    };

    const openModal = () => {
        isOpen.value = true
    }

    const closeModal = () => {
        isOpen.value = false
    }
</script>

<template>
    <Block 
        :class="[
            'relative flex',
            props.class
        ]"
    >
        <Block class="relative flex w-full flex-col">
            <CustomIcon
                v-if="props.icon !== ''"
                class="absolute top-[50%] left-[1rem] translate-y-[-50%] w-[1rem] h-[1rem] text-[1.4rem] z-10 ant-select-suffix"
                :name="props.icon"
            />
            <a-select 
                :class="[
                    { 'is-invalid' : errorMessage },
                    'w-full dropdown text-[1.4rem] font-bold text-[darkGray] placeholder-[darkGray] shadow', 
                    { 'with-icon' : props.icon !== '' },
                    classObject, 
                    props.class,
                ]"
                :id="props.inputName"
                :name="props.inputName"
                mode="multiple"
                :open="false"
                :labelInValue="true"
                :placeholder="props.placeholder"
                :allowClear="true"
                :value="value"
                @click="openModal"
                @change="updateValue">
            </a-select>
            <template v-if="errorMessage">
                <p class="text-[redError] text-[1.4rem] leading-[1.5] mt-[.4rem]">
                {{  errorMessage }}
                </p>
            </template>
        </Block>

        <a-modal
            v-if="viewport.isGreaterThan('sp')"
            :centered="true"
            :width="568"
            v-model:open="isOpen" 
            @cancel="closeModal()">

            <Block class="pt-[2rem]">
                <Block class="px-[3.6rem] border-b-[1px]">
                    <TitleText type="4">
                        Select Category
                    </TitleText>
                    <Block class="mt-[.8rem] pb-[1rem]">
                        <dl class="flex items-center">
                            <dt class="text-[1.4rem] leading-[1.5] min-w-[17.4rem]">Maximum of two choices</dt>
                        </dl>
                    </Block>
                </Block>
                <Block class="px-[3.6rem] pb-[2rem] border-b-[1px]">
                    <form 
                        ref="form"
                    >
                        <p class="mt-[1.6rem] text-[1.8rem] font-bold">Country</p>
                        <Block class="flex flex-wrap">
                            <a-checkable-tag
                                class="mt-[8px] tag px-[10px] py-[7px] flex items-center justify-center"
                                v-for="(tag, index) in countryTagList"
                                :key="tag.value"
                                v-model:checked="countryTagList[index].checked"
                                @change="checked => handleChange(tag, checked, 'country')"
                                >
                                {{ tag.label }}
                            </a-checkable-tag>
                        </Block>

                        <p class="mt-[1.6rem] text-[1.8rem] font-bold">Type of Dish</p>
                        <Block class="flex flex-wrap">
                            <a-checkable-tag
                                class="mt-[8px] tag px-[10px] py-[7px] flex items-center justify-center"
                                v-for="(tag, index) in dishTagList"
                                :key="tag.value"
                                v-model:checked="dishTagList[index].checked"
                                @change="checked => handleChange(tag, checked, 'dish')"
                                >
                                {{ tag.label }}
                            </a-checkable-tag>
                        </Block>
                    </form>
                </Block>
            </Block>

            <template #footer>
                <Block class="mt-[2.4rem] px-[3.6rem] pb-[2rem] flex justify-center gap-[2.4rem]">
                    <button
                        class="text-[1.4rem] leading-[1.5] font-bold text-[primary] border-[.1rem] border-[darkGray] rounded-[1rem] max-w-[25.2rem] w-full p-[.8rem]"
                        @click="closeModal">Cancel
                    </button>
                    <button
                        @click="setCategory"
                        class="text-[1.4rem] leading-[1.5] font-bold text-[primary] rounded-[1rem] max-w-[25.2rem] w-full p-[.8rem] bg-[goldenYellow] hover:bg-[darkYellow] transition ease-in-out delay-150">Set Category
                    </button>
                </Block>
            </template>

        </a-modal>

        <!-- <a-drawer
            v-else
            class="drawer-class"
            v-model:open="isOpen"
            title="Select City"
            width="100%"
            placement="right"
        >

            <template #closeIcon>
                <CustomIcon
                  class=""
                  name="back"
                />
            </template>

            <Block>
                <div class="w-full bg-[white]">
                    <div class="w-full" v-for="area, areaIndex in citiesData" :key="areaIndex">
                        <div :class="[
                            { 'mt-[2rem]' : areaIndex > 0 },
                            'w-full font-bold py-[.4rem] px-[1.6rem] bg-[bgSecond] text-[1.8rem] leading-[1.5] block'
                        ]">{{ area.title }}</div>
                        <ul :class="[
                            'mt-[2rem] grid grid-cols-1 gap-4',
                        ]">
                            <li v-for="city, cityIndex in area.items" :key="cityIndex">
                                <button 
                                    @click="setCategory(city)"
                                    class="font-normal px-[1.6rem] text-[1.6rem] leading-[1.5] block hover:underline hover:text-[blueLink] text-left">{{ city.name }}
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </Block>
        </a-drawer> -->
    </Block>
</template>